import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';

import _ from 'lodash';
import $ from 'jquery';

@Component({
    selector: 'users-groups',
    template: require('./users-groups.component.html'),
    styles: [require('./users-groups.component.scss')]
})
export class UsersGroupsComponent implements OnInit, OnDestroy {
    public userGroups: any[];
    public group: any;
    public listMenu: any;

    private unSubscribers: any[] = [];
    private unSubscribe: any;
    private unsubscribe: any;
    private indexInList: any;

    constructor(
        private store: Store,
        @Inject('$state') private $state: any) {
    }

    public ngOnInit() {
        this.isGlobalAdmin();
        this.unSubscribers.push(this.store.subscribe(() => {
            const userState = this.store.getState().user;
            if (userState.userGroups) {
                const newItems = _.filter(this.userGroups, (i: any) => i.isNew && i.name !== this.group.name);
                if (newItems.length > 0) {
                    this.userGroups = newItems.concat(userState.userGroups);
                } else {
                    this.userGroups = userState.userGroups;
                }
            }
        }));
        this.store.dispatch({ type: userActions.GET_USER_GROUPS });
    }

    public ngOnDestroy() {
        if (this.unSubscribers) {
            this.unSubscribers.forEach((x: any) => x());
        }
        if (this.unSubscribe) {
            this.unSubscribe();
        }
    }

    private isGlobalAdmin() {
        this.unsubscribe = this.store.subscribe(() => {
            const user = this.store.getState().user;
            if (user && user.checkingPermissions) {
                this.isGlobalAdmin = user.checkingPermissions.find((x: any) => x.key === 'Admin' && x.value === true);
                if (this.isGlobalAdmin) {
                    this.listMenu = this.$state.params.listMenu;
                }
                this.unsubscribe();
            }
        });
    }

    public getGroup(selectedGroup: any, indexInList: any) {
        this.indexInList = indexInList;
        if (selectedGroup.isNew) {
            this.group = selectedGroup;
            this.unSubscribe = this.store.subscribe(() => {
                if (this.store.getState().user.group) {
                    if (selectedGroup.id === -1 && this.group) {
                        selectedGroup.id = this.group.id;
                    }
                }
            });
            return;
        }

        this.unSubscribers = [
            this.store.subscribe(() => {
                const groupState = this.store.getState().user.group;
                if (groupState) {
                    this.group = groupState;
                }
            })
        ];
        if (selectedGroup.id !== -1) {
            this.store.dispatch({
                type: userActions.GET_GROUP,
                payload: { groupId: selectedGroup.id }
            });
        }
    }

    public addUserGroup() {
        this.group = { name:'New Group', isNew: true };
        this.userGroups = [this.group , ...this.userGroups];
        this.indexInList = 0;
        this.getGroup(this.group, 0);
        setTimeout(() => { $('ul.dbm-list > li:first-child').click(); }, 50);
    }

    public deleteGroup() {
        if (this.group.isNew) {
            if (this.indexInList >= 0) {
                this.userGroups = [
                    ...this.userGroups.slice(0, this.indexInList),
                    ...this.userGroups.slice(this.indexInList + 1)
                ];
                this.group = this.userGroups ? this.userGroups[0] : null;
            }
            return;
        }
        this.unSubscribe = this.store.subscribe(() => {
            const userState = this.store.getState().user;
            if (userState.userGroups) {
                if (this.userGroups.length > userState.userGroups.length) {
                    this.userGroups = userState.userGroups;
                    this.group = userState.group;
                    this.unSubscribe();
                }
            }
        });
        this.store.dispatch({
            type: userActions.DELETE_GROUP,
            payload: { groupId: this.group.id }
        });
    }

    public duplicateGroup() {
        this.store.dispatch({
            type: userActions.DUPLICATE_GROUP,
            payload: { groupId: this.group.id }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users-groups/users-groups.component.ts